<template>
    <div v-loading="loading">
        <navBox></navBox>
        <!-- <div class="banner" v-if="types == 'show'">
            <img :src="fullpathImg" alt="" />
        </div>
        <div class="banner" v-if="types == 'link'">
            <router-link :to="{ path: pathUrl }">
                <img :src="fullpathImg" alt="" />
            </router-link>
        </div> -->
        <div class="banner">
                <img src="@/assets/News/banner.png" alt="" />
        </div>
        <div class="wrap content">
            <div class="title-navBox">
                <div>
                    <span @click="show(1)" :class="index == 1 ? 'active' : ''"
                        >PRESS RELEASES</span
                    >
                </div>
                <label>|</label>
                <div>
                    <span @click="show(2)" :class="index == 2 ? 'active' : ''"
                        >IN THE NEWS</span
                    >
                </div>
            </div>
            <transition name="fade">
                <div class="content-ul" v-show="index == 1 && isShow">
                    <ul>
                        <li
                            v-for="(item, index) in (NewsListpg2 || '').slice(
                                (page - 1) * pagesize,
                                page * pagesize
                            )"
                            :key="index"
                        >
                            <div class="title">
                                {{ item.title }}
                            </div>
                            <div class="date">
                                {{item.utime}}
                            </div>
                            <div
                                class="content-text"
                                v-html="item.explain"
                            ></div>
                            <div class="more">
                                <router-link :to="{ path: '/NewsDetails',query:{id:item.id}}">
                                    <img
                                        src="@/assets/News/more.png"
                                        alt=""
                                    /><span>Read more</span>
                                </router-link>
                            </div>
                        </li>
                    </ul>
                    <div class="wrap pagination">
                        <el-pagination
                            background
                            layout="prev, pager, next"
                            :page-size="pagesize"
                            @current-change="handleCurrentChange"
                            :total="total1"
                        >
                        </el-pagination>
                    </div>
                </div>
            </transition>
            <transition name="fade">
                <div v-show="index == 2 && isShow" class="news-list">
                    <div class="in-news">
                        <div class="left-img">
                            <div>
                                <img :src="this.NewsListpg3[0].mainpic_fullpath" alt="" />
                            </div>
                        </div>
                        <div class="right-content">
                            <div class="title">
                                {{NewsListpg3[0].title}}
                            </div>
                            <div class="date">
                               {{NewsListpg3[0].ctime}}
                               <router-link :to="{ path: '/NewsDetails',query:{id:NewsListpg3[0].id}}"> 
                                <span style="margin-left:100px;">
                                    <img
                                        src="@/assets/News/more.png"
                                        alt=""
                                        
                                    /><span style="position: relative;top: 6px;left: 5px;">Read more</span>
                                </span>   
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="games-list">
                        <ul>
                            <li v-for="(item, index) in (NewsListpg3.slice(1) || '').slice(
                                (page2 - 1) * pagesize2,
                                page2 * pagesize2
                            )"
                            :key="index">
                                <div class="img">
                                    <img
                                        :src="item.mainpic_fullpath"
                                        alt=""
                                    />
                                </div>
                                <div class="title" :title="item.title">
                                    {{item.title.length>20?item.title.substring(0,20)+"...":item.title}}
                                </div>
                                <div class="date">
                                    {{item.ctime}}
                                </div>
                                <div class="more">
                                    <router-link :to="{ path: '/NewsDetails',query:{id:item.id}}">    
                                    <img
                                        src="@/assets/News/more.png"
                                        alt=""
                                    /><span>Read more</span>
                                    </router-link>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="wrap pagination">
                        <el-pagination
                            background
                            layout="prev, pager, next"
                            :page-size="pagesize2"
                            @current-change="handleCurrentChange2"
                            :total="total2"
                        >
                        </el-pagination>
                    </div>
                </div>
            </transition>
        </div>

        <div class="pl"></div>
        <footerBox></footerBox>
    </div>
</template>
<script>
import navBox from "@/components/navBox/navBox";
import footerBox from "@/components/footerBox/footerBox";
export default {
    name: "News",
    components: { footerBox, navBox },
    data() {
        return {
            index: 1,
            isShow: true,
            NewsListpg2: [],
            total1: 0,
            pagesize: 5,
            page: 1,
            NewsListpg3:[
                {
                    mainpic_fullpath:'',
                    title:'',
                    ctime:''
                }
                ],
            total2: 0,
            pagesize2: 5,
            page2: 1,
            loading:false,
            types: "",
            fullpathImg:"",
            pathUrl:'',
        };
    },
    created() {
        this.getNewsListpg2();
        this.getNewsListpg3();
    },
    methods: {
        getNewsListpg2() {
            this.loading=true;
            this.$http.getNewsListpg2().then((res) => {
                this.NewsListpg2 = res.list;
                this.total1 = res.page.total;
                this.page = res.page.page;
                this.pagesize = res.page.pagesize;
                this.loading=false;
            });
        },
        getNewsListpg3(){
            this.loading=true;
            this.$http.getNewsListpg3().then((res)=>{
                this.NewsListpg3 = res.list;
                this.total2 = res.page.total;
                this.page2 = res.page.page;
                this.pagesize2 = res.page.pagesize;
                 this.loading=false;
            })
        },
        handleCurrentChange(val) {
            this.page = val;
        },
        handleCurrentChange2(val) {
            this.page2 = val;
        },
        show(value) {
            //this.index === value? (this.isShow = !this.isShow): (this.isShow = true);
            this.index = value;
        },
    },
};
</script>
<style lang="less" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter,
    .fade-leave-to
    /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
.wrap {
    width: 1200px;
    margin: 0 auto;
}
/*banner*/
.banner img {
    width: 100%;
    // height: 220px;
}
//正文
.content {
    margin: 45px auto 0 auto;
}
.pl {
    height: 85px;
} //间距
.title-navBox {
    display: flex;
    height: 80px;
    line-height: 80px;
    background: #f2f2f2;
    .active {
        border-bottom: 3px solid #0e397f;
    }
    span {
        cursor: pointer;
        display: inline-block;
        height: 74px;
        line-height: 74px;
    }
}
.title-navBox div {
    width: 49.5%;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: #333333;
}
.title-navBox label {
    color: #bfbfbf;
}
.content-ul ul li {
    padding: 60px 45px;
    border-bottom: 1px solid #e9e9e9;
    .title {
        color: #333333;
        font-size: 32px;
        padding-bottom: 20px;
    }
    .date {
        font-size: 13px;
        color: #888888;
        padding-bottom: 45px;
    }
    .content-text {
        color: #444444;
        font-size: 18px;
        padding-bottom: 25px;
        font-family: 'Lucida Bright';
    }
    .more {
        color: #666666;
        img {
            cursor: pointer;
        }
        span {
            border-bottom: 1px solid #a9a9a9;
            margin-left: 10px;
            position: relative;
            top: 5px;
            font-size: 12px;
            cursor: pointer;
        }
    }
}
.news-list {
    .in-news {
        display: flex;
        margin-top: 50px;
        .left-img {
            img {
                width: 625px;
                height: 350px;
            }
        }
        .right-content {
            margin-left: 30px;
            .title {
                font-size: 30px;
                font-weight: bold;
                margin-top: 35px;
                color: #333333;
            }
            .date {
                color: #888888;
                font-size: 13px;
                margin-top: 60px;
            }
        }
    }
    .games-list {
        margin-top: 75px;
        ul {
            display: flex;
            flex-wrap: wrap;
            li {
                width: 385px;
                height: 490px;
                border-bottom: 1px solid #ececec;
                display: inline-block;
                margin-right: 15px;
                margin-bottom: 50px;
                .img {
                    img {
                        width: 385px;
                        height: 235px;
                    }
                }
                .title {
                    margin-top: 25px;
                    font-size: 28px;
                    color: #333333;
                }
                .date {
                    color: #888888;
                    font-size: 13px;
                    margin-top: 20px;
                }
                .more {
                    font-size: 12px;
                    color: #666666;
                    margin-top: 70px;
                    span {
                        position: relative;
                        top: 10px;
                        left: 10px;
                    }
                }
            }
        }
    }
}
//分页
.pagination {
    text-align: center;
    margin-top: 50px;
}
</style>